import { Component } from "react";
import * as MUIcon from "@mui/icons-material";
import { IconProps } from "./models";

class IconComp extends Component<IconProps> {
  render() {
    const { icon } = this.props;
    const Icon = icon && MUIcon[icon];
    return <div>{Icon && <Icon sx={{color: this.props.color, fontSize: 150}}/>}</div>;
  }
}

export default IconComp;
